<script>
	import { beforeUpdate } from "svelte";
	import Summary from "./Summary.svelte";

	const PAGE_SIZE = 20;

	export let page;

	let items;
	let offset;

	$: fetch(`https://api.hackerwebapp.com/news?page=${page}`)
		.then(r => r.json())
		.then(data => {
			items = data;
			offset = PAGE_SIZE * (page - 1);
			window.scrollTo(0, 0);
		});
</script>

<style>


	.loading {
		opacity: 0;
		animation: 0.4s 0.8s forwards fade-in;
	}

	@keyframes fade-in {
		from { opacity: 0; }
		to { opacity: 1; }
	}
	
	h1{
	font-family:"opendyslexic3-bold";
	color: #0098C6;
	}
	
	h1 a {
		color: #0098C6;
	}
	
	h2{
	font-family:"opendyslexic3-bold";
	color:#34B16F;
	font-size:18px;	
		
	}
	
	footer a {
		color:#34B16F;
	}

container {
	display: flex;
	justify-content: space-beteen;
}
	
</style>
<container>
<h1> <a href="/"> 📰Neu.sh </a></h1> 
<h2>HN Clone with Open Dyslexic Font </h2>
</container>


{#if items}
	{#each items as item, i}
		<Summary {item} {i} {offset}/>
	{/each}

	<a href="#/top/{page + 1}">page {page + 1}</a>
{:else}
	<p class="loading">loading...</p>
{/if}

<footer>
	<a href="https://david.dev"> made with 💙 by David.Dev </a> 
	</footer>
